import * as React from 'react';

interface TransportLine {
  id: string | number;
  coordinates: number[][] | number[][][];
  scope: string;
  mode: string;
  label: string;
}

interface TransportLinesResponse {
  data: TransportLine[];
}

export function useTransportGeoJson(transportLines: TransportLinesResponse | undefined) {
  return React.useMemo(() => {
    const features = transportLines?.data ?? [];
    return {
      type: 'FeatureCollection' as const,
      features: features.map((f) => {
        const isMulti = Array.isArray(f.coordinates[0]?.[0]);
        return {
          type: 'Feature' as const,
          id: f.id,
          geometry: isMulti
            ? { type: 'MultiLineString' as const, coordinates: f.coordinates as number[][][] }
            : { type: 'LineString' as const, coordinates: f.coordinates as number[][] },
          properties: { scope: f.scope, mode: f.mode, label: f.label },
        };
      }),
    };
  }, [transportLines]);
}
